import React from 'react';
import { Route } from 'react-router-dom';
import LazyRoute from '../components/helpers/LazyRoute';

import { Login, Register, DefinirNovaSenha, VerificarEmail } from '../utils/lazyImports';
import RecuperarSenha from 'pages/RecuperarSenha';

export const AuthRoutes = (
  <>
    <Route path="/login" element={<LazyRoute><Login /></LazyRoute>} />
    <Route path="/registro" element={<LazyRoute><Register /></LazyRoute>} />
    <Route path="/recuperar-senha" element={<RecuperarSenha />} />
    <Route path="/definir-nova-senha/:token" element={<LazyRoute><DefinirNovaSenha /></LazyRoute>} />
    <Route path="/redefinir-senha" element={<LazyRoute><DefinirNovaSenha /></LazyRoute>} />
    <Route path="/verificar-email" element={<LazyRoute><VerificarEmail /></LazyRoute>} />
  </>
);
